<template>

  <div class="fixOrderNow">
    <v-container class="pointer cc">

      <!--            <div>UseCase: {{useCase}}</div>-->
      <!--            <div class="maxw pb-4">-->
      <!--                <v-btn-toggle v-model="useCase" exclusive>-->
      <!--                    <v-btn>-->
      <!--                        <v-icon>mdi-food-takeout-box</v-icon>-->
      <!--                        Hier Essen-->
      <!--                    </v-btn>-->
      <!--                    <v-btn>-->
      <!--                        <v-icon>mdi-food-takeout-box</v-icon>-->
      <!--                        Abholung-->
      <!--                    </v-btn>-->
      <!--                    <v-btn>-->
      <!--                        <v-icon>mdi-food-takeout-box</v-icon>-->
      <!--                        Lierferung-->
      <!--                    </v-btn>-->
      <!--                </v-btn-toggle>-->
      <!--            </div>-->

      <div class="d-flex align-content-stretch">

        <!--                <div class="summe">-->
        <!--                    {{$store.getters.payerSum | price}}-->
        <!--                </div>-->

        <div class="leftPart flex50 text-center"
             :class="{rounderRight: $store.getters.orderingEnabled === false}"
             @click.passive="$emit('more')"
        >
          <div class="maxh superCenter mehr">
            <div>Mehr hinzufügen</div>
          </div>
        </div>

        <div class="rightPart flex50 text-center orderPulsing" @click.passive="clickRight"
             v-if="$store.getters.orderingEnabled"
        >
          <div v-if="isSimpleCase" class="maxh d-flex justify-center align-center"
          >
            <v-icon left class="mr-1 myWhite">mdi-send</v-icon>
            <div style="color:white" class="ml-1 titleFont ">
              Jetzt Bestellen
            </div>
          </div>
          <div v-else class="maxh d-flex justify-center align-center"
          >
            <v-icon left class="mr-1 myWhite">mdi-cart-arrow-right</v-icon>
            <div style="color:white" class="ml-1 titleFont ">
              Bestätigen
            </div>
          </div>
        </div>
      </div>

    </v-container>

  </div>

</template>

<script>
import store from '../store/store'
import * as qconst from '../vendor/qconstants';

export default {
  //     name: "fixOrderNow",
  data: () => ({
      isSimpleCase: store.getters.inhouse && store.getters.table && qconst.enableInhouseOhnePay && !store.getters.enableInhousePay && !this.$store.getters.selfServiceEnabled,
      useCase: 0,
    }
  ),
  computed: {},
  methods: {
    clickRight() {
      if (this.isSimpleCase) {
        this.$emit('ordernow');
      } else {
        this.$emit('next');
      }
    },
  },
//
}
</script>

<style lang="scss" scoped>
@import '../styles/base';

.mehr {
  /*font-size: 1.1em;*/
  /*font-weight: bold;*/
}

.flex50 {
  flex: 1 0 50%;
  height: auto;
  min-height: 60px;
  padding: 0 2.5vw;
}

.leftPart {
  border-top-left-radius: $button-border-radius;
  border-bottom-left-radius: $button-border-radius;
  background-color: $color-primary;
  color: white;

  &.rounderRight {
    border-top-right-radius: $button-border-radius;
    border-bottom-right-radius: $button-border-radius;
  }
}

.rightPart {
  border-top-right-radius: $button-border-radius;
  border-bottom-right-radius: $button-border-radius;
  background-color: $buttonGreen;
  color: white;
}

.cc {
  padding-left: 10px;
  padding-right: 10px;
}

.fixOrderNow {
  z-index: 200;
  text-align: center;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  overflow: hidden;
  /*padding: 15px 15px 15px 30px;*/
  /*clip-path: polygon( 30% 0, !* left top *! 100% 0, !* right top *! 100% 100%, !* right bottom *! 0 100% !* left bottom *! );*/
  /*clip-path: polygon( 0 0, !* left top *! 100% 0, !* right top *! 100% 80%, !* right bottom *! 0 100% !* left bottom *! );*/
}


</style>
